import { render, staticRenderFns } from "./createCampaign.vue?vue&type=template&id=2e67b220&scoped=true"
import script from "./createCampaign.vue?vue&type=script&lang=js"
export * from "./createCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67b220",
  null
  
)

export default component.exports